// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1941":"f8753fabd7183d72","2396":"f8753fabd7183d72","2888":"c303082beec9156c","8712":"f8753fabd7183d72"}[chunkId] + ".css";
};